import {createApi} from "@reduxjs/toolkit/query/react";
import {baseQueryWithReAuth} from "@/store/api/baseQueryWithReAuth";


export interface BDShareholder {
    id: number | string;
    first_name: string;
    last_name: string;
    email: string;
    date_of_barth: string;
    contact: string;
    country_code: string;
    address: string;
    ownership: string;
    director_status: boolean;
    chairman_status: boolean;
    managing_director: boolean;
    passport_or_nid_number: string;
    nationality: string;
}

export const bdShareholderApi = createApi({
    reducerPath: "BDShareholderApi",
    baseQuery: baseQueryWithReAuth,
    endpoints: (builder) => ({
        getBDShareholder: builder.query<BDShareholder, number>({
            query: (companyID) => `/client-shareholder-bd/${companyID}`
        })
    })
})

export const { useGetBDShareholderQuery } = bdShareholderApi